import { HomeworkGrid } from 'components/Homeworks/components/HomeworkGrid/HomeworkGrid';
import { useIsDesktop } from 'hooks/useIsDesktop';
import { useStackHandler } from 'hooks/useStackHandler';
import i18next from 'i18next';
import { AbsencesEvaluationSubpage } from 'pages/Absences/subpages/AbsencesEvaluationSubpage';
import { useEffect, useMemo } from 'react';
import { matchRoutes, RouteObject, useLocation } from 'react-router-dom';
import { AbsencesAdministrationSubpage } from './pages/Absences/subpages/AbsencesAdministrationSubpage';
import { MyAbsencesSubpage } from './pages/Absences/subpages/MyAbsencesSubpage';

type RouteObjectWithMeta = {
  path: Pick<RouteObject, 'path'>['path'];
  element: Pick<RouteObject, 'element'>['element'];
  group: 'classbook' | 'absences';
  title: string;
  rootPath?: string;
};

const mobileRoutes: RouteObjectWithMeta[] = [
  {
    path: '/absences/my-absences',
    element: <MyAbsencesSubpage />,
    group: 'absences' as const,
    title: i18next.t('absences.myAbsences'),
  },
  {
    path: '/absences/administration',
    element: <AbsencesAdministrationSubpage />,
    group: 'absences' as const,
    title: i18next.t('absences.administration'),
  },
  {
    path: '/absences/evaluation',
    element: <AbsencesEvaluationSubpage />,
    group: 'absences' as const,
    title: i18next.t('absences.evaluation.title', { count: 1 }),
  },
];

export const MobileRouteHandler = () => {
  const location = useLocation();
  const handler = useStackHandler();
  const isDesktop = useIsDesktop();
  const isNative = useMemo(() => !isDesktop, [isDesktop]);

  useEffect(() => {
    if (!isNative) return;
    const matches = matchRoutes(mobileRoutes, location);
    if (matches && matches.length > 0) {
      const match = matches[0];
      const route = match.route;
      handler.push({
        id: `route-${location.pathname}`,
        title: route.title,
        group: route.group,
        component: route.element,
      });
    } else {
      handler.clear();
    }
  }, [location, isNative, handler]);

  return null;
};
